// 防止circle import
let vue = async () => {
    return (await import("../main")).vue;
};

export async function msgSuccess(msg = "操作成功") {
    let v = await vue();
    v.$message.success(msg);
}

export async function msgError(msg) {
    let v = await vue();
    v.$message.error(msg);
}

export async function actionConfirm() {
    let v = await vue();
    return v.$confirm("是否确认操作？");
}
